import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import Svg from '@components/svg'
import { switchOff, switchOn } from '@assets/icons'
import generalSettings from '@apis/generalSettings'
import Wrapper from '@components/wrapper'
import {
  StyleContent,
  StyleMaintainanceWrapper,
  Stylesubtitle,
  StyleTitle,
} from '../style'
import styled from '@emotion/styled'

const StatusText = styled.span<any>`
  margin-right: 12px;
  font-weight: 500;
  color: ${(props: any) => (props.enabled ? '#27ae60' : '#b9b9b9')};
`

const MaintainanceMode = () => {
  const { data: mode } = useSelector(
    (state: RootState) => state.maintainanceMode,
  )

  // Fetch current mode on mount
  const fetchMode = async () => {
    try {
      await generalSettings.getByKey({
        id: 'maintenance-mode',
        state: 'maintainanceMode',
      })
    } catch (err) {
      console.error('Failed to fetch maintenance mode', err)
    }
  }

  useEffect(() => {
    fetchMode()
  }, [])

  const toggleMode = async () => {
    try {
      if (!mode?.id) {
        await generalSettings.create({
          data: JSON.stringify({
            group: 'platform-settings',
            key: 'maintenance-mode',
            value: 'true',
          }),
          state: 'maintainanceMode',
        })
      } else {
        await generalSettings.update({
          id: mode.id,
          state: 'maintainanceMode',
          data: {
            key: mode.key,
            value: mode.value === 'true' ? 'false' : 'true',
          },
        })
      }
    } catch (err) {
      console.error('Failed to toggle maintenance mode', err)
    }
  }

  const isEnabled = mode?.value === 'true'

  return (
    <Wrapper>
      <StyleMaintainanceWrapper>
        <StyleContent>
          <StyleTitle>Enable Maintenance Mode</StyleTitle>
          <Stylesubtitle>
            Activating Maintenance Mode will temporarily pause the app for all
            users. While enabled, users cannot interact with the app and will
            instead see a static maintenance screen. Useful for updates, server
            work, or critical changes requiring uninterrupted access.
          </Stylesubtitle>
        </StyleContent>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            background: '#e9f5ff',
            padding: '12px',
            borderRadius: '8px',
            marginTop: '12px',
          }}
        >
          <StatusText enabled={isEnabled}>
            {isEnabled ? 'Enabled' : 'Disabled'}
          </StatusText>
          <Svg src={isEnabled ? switchOn : switchOff} onClick={toggleMode} />
        </div>
      </StyleMaintainanceWrapper>
    </Wrapper>
  )
}

export default MaintainanceMode
